export default "__VITE_ASSET__BPtF22D$__"